import React from 'react';
import { Box, Typography } from '@mui/joy';

const SupplierPortalPage: React.FC = () => (
  <Box sx={{ p: 3, maxWidth: 640, mx: 'auto' }}>
    <Typography level="h3" sx={{ mb: 1 }}>Supplier portal</Typography>
    <Typography level="body-md" sx={{ color: 'neutral.600' }}>
      Supplier access is not available yet. You can sign out from the menu at the bottom of the sidebar.
    </Typography>
  </Box>
);

export default SupplierPortalPage;
